import styled from "styled-components";
// ContentFormatter is needed to to get styling from RCL
import { ContentFormatter } from "@ebscois/react-component-library";

export const ContentBlockItemWrapper = styled.div`
  @media print {
    display: ${({ printHide }) => printHide && "none"};
  }
`;

export const StyledChecklist = styled(ContentFormatter)`
  ol li::before {
    content: "";
    @media print {
      position: absolute;
      left: -60px;
      content: "";
      display: inline-block;
      float: left;
      width: 1.6rem;
      height: 1.6rem;
      margin: -0.3rem 0.5rem 0 0.1rem;
      border: 1px solid ${({ theme }) => theme.colors.gray400};
    }
  }

  li {
    list-style-type: decimal !important;
    @media print {
      position: relative;
      margin-left: 3rem;
    }
  }

  &:not(:first-child) {
    padding-top: ${({ theme }) => theme.space.sm};
  }
`;
